import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchUsers, deleteUser, fetchUsersByIds } from '../services/userService';
import { toast } from 'react-toastify';

export const useFetchUsers = (currentPage, search, lastLogin, userType, enrollmentDate, organization, plan, planType, statusType) => {
    return useQuery({
        queryKey: ['users', { currentPage, search, lastLogin, userType, enrollmentDate, organization, plan, planType , statusType }],
        queryFn: fetchUsers,
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};

const EMPTY_USERS_MAP = new Map();
export const useUsersByIds = (ids) => {
    const uniqueIds = [...new Set(ids.filter((id) => id !== undefined && id !== null && id !== '').map(String))].sort();
    const { data } = useQuery({
        queryKey: ['users', 'by-ids', uniqueIds],
        queryFn: () => fetchUsersByIds(uniqueIds),
        enabled: uniqueIds.length > 0,
        staleTime: 5 * 60 * 1000,
        retry: false,
        select: (users) => new Map(users.map((user) => [String(user.id), user])),
    });
    return data || EMPTY_USERS_MAP;
};

export const useDeleteUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteUser,
        onSuccess: (response) => {
            if (response.status === 200 || response.status === 201) {
                toast.success(response?.data?.message);
                queryClient.invalidateQueries(['users']); // Refetch users on successful deletion
            }
        },
        onError: () => {
            toast.error('Error deleting user.');
        },
    });
};
